<template>
    <div class="sponsors">
        <div class="title">
            <h3>
                <em></em>
                <span>{{ t('sponsors.title') }}</span>
                <em></em>
            </h3>
        </div>
        <div class="sponsor-carousel">
            <el-carousel height="200px" :autoplay="true" :interval="3000" indicator-position="none" arrow="always">
                <el-carousel-item v-for="(group, index) in sponsorGroups" :key="index">
                    <div class="sponsor-group">
                        <div v-for="sponsor in group" :key="sponsor.id" class="sponsor-item">
                            <a :href="sponsor.link" target="_blank">
                                <img :src="require(`@/assets/sponsors/${sponsor.image}`)" :alt="sponsor.name" />
                                <!-- <p>{{ sponsor.name }}</p> -->
                            </a>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()

const sponsorList = ref([
    {
        id: 1,
        name: 'revvity',
        link: '#',
        image: 'revvity.png',
    },
    {
        id: 2,
        name: '集萃药康',
        link: '#',
        image: '集萃药康.png',
    },
    // {
    //     id: 3,
    //     name: 'JUNYU',
    //     link: '#',
    //     image: 'JUNYU.png',
    // },
    {
        id: 3,
        name: 'Evident',
        link: '#',
        image: 'Evident.png',
    },
    {
        id: 4,
        name: 'RWD',
        link: '#',
        image: 'rwd.png',
    }
])

// 将赞助商列表按每4个一组进行分组
const sponsorGroups = computed(() => {
    const groups = []
    for (let i = 0; i < sponsorList.value.length; i += 4) {
        groups.push(sponsorList.value.slice(i, i + 4))
    }
    return groups
})

</script>

<style scoped lang="scss">
.sponsors {
    padding: 40px 0;
    .title {
        h3 {
            font-size: 30px;
            font-weight: bold;
            text-align: center;
            color: #303030;
            margin-bottom: 40px;

            span {
                margin: 0 40px;
            }

            em {
                display: inline-block;
                width: 54px;
                height: 14px;
                margin-bottom: 0;
                background: url('@/assets/tt.png');
                vertical-align: middle;
            }
        }
    }

    .sponsor-carousel {
        max-width: 1440px;
        margin: 0 auto;
        padding: 0 20px;

        .sponsor-group {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 20px;
            height: 100%;
            padding: 10px;

            .sponsor-item {
                flex: 1;
                max-width: 280px;
                height: 100px;
                border: 1px solid #e0e0e0;
                border-radius: 10px;
                text-align: center;

                a {
                    display: block;
                    text-decoration: none;
                    color: inherit;
                    width: 100%;
                    height: 100%;
                    transition: transform 0.3s ease;


                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }

                    p {
                        font-size: 14px;
                        color: #666;
                        margin: 0;
                        font-weight: 500;
                    }
                }
            }
        }
    }

    // 响应式设计
    @media (max-width: 768px) {
        .title {
            em {
                width: 40px !important;
            }

            span {
                font-size: 22px;
                margin: 0 10px !important;
            }
        }
        .sponsor-carousel {
            .sponsor-group {
                gap: 15px;
                padding: 10px;
                flex-direction: column;
                .sponsor-item {
                    max-width: 150px;

                    a {
                        img {
                            height: 80px;
                        }

                        p {
                            font-size: 12px;
                        }
                    }
                }
            }
        }
    }
}
</style>